import * as React from 'react'
import Text from './Text'

export default function Label(lableProps: { text: string, required?: boolean }) {
  return (
    <Text style={{ marginTop: 20 }}>{lableProps.text}{(lableProps.required ?? false) && '*'}</Text>
  )
}
